export default function ProposalIcon() {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 12.5H9M6 9.5H12M6 6.5H12M17.1821 12.4993H12V17.6818M11.6893 17.75H1.5C1.30109 17.75 1.11032 17.671 0.96967 17.5303C0.829018 17.3897 0.75 17.1989 0.75 17V2C0.75 1.80109 0.829018 1.61032 0.96967 1.46967C1.11032 1.32902 1.30109 1.25 1.5 1.25H16.5C16.6989 1.25 16.8897 1.32902 17.0303 1.46967C17.171 1.61032 17.25 1.80109 17.25 2V12.1893C17.25 12.2878 17.2306 12.3854 17.1929 12.4764C17.1552 12.5673 17.1 12.65 17.0303 12.7197L12.2197 17.5303C12.15 17.6 12.0673 17.6552 11.9764 17.6929C11.8854 17.7306 11.7878 17.75 11.6893 17.75Z"
        stroke="#B721FF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
